import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";

const Main = lazy(() => import("../../components/activities/allActivities/main"));

const Activities = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default Activities;

